export const STATISTIC_RESULT = 'StatisticResult';
export const SCORE_RESULT = 'ScoreResult';
export const ROSTER_RESPONSE = 'RosterResponse';
export const ROSTER_STUDENT_RESPONSE = 'RosterStudentResponse';